module.exports = __webpack_public_path__ + "static/media/frontpage.36748ac0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/structure/page/frontpage.jpg
// module id = 164
// module chunks = 0